import { render, staticRenderFns } from "./StruttureList.vue?vue&type=template&id=584aa97e"
import script from "./StruttureList.vue?vue&type=script&lang=js"
export * from "./StruttureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports